import { PrizepicksSwitch } from '@library/components/switches';
import { cn } from '@library/component-utils/cn';
import { selectHasCreateWinProtectedUnsettlements } from '@bo-selectors/unsettlements/unsettlementsPermissons';
import { useSelector } from 'react-redux';

interface WinProtectionToggleProps {
  isDisabled: boolean;
  isWinProtected?: boolean;
  onToggle?: (checked: boolean) => void;
}

export const WinProtectionToggle = ({
  isDisabled,
  isWinProtected = false,
  onToggle = () => {}
}: WinProtectionToggleProps) => {
  const hasCreateWPUnsettlements = useSelector(
    selectHasCreateWinProtectedUnsettlements
  );

  const isToggleDisabled = isDisabled || !hasCreateWPUnsettlements;

  return (
    <div className="mt-6 flex items-center gap-x-4">
      <PrizepicksSwitch
        active={isWinProtected}
        disabled={isToggleDisabled}
        handleChange={onToggle}
        id="enable-win-protection"
        testId="enable-win-protection"
      />
      <label
        className={isToggleDisabled ? 'text-soClean-180' : 'text-soClean-100'}
        htmlFor="enable-win-protection"
      >
        Enable win protection
        <p
          className={cn(
            'text-xs',
            isToggleDisabled ? 'text-soFresh-160' : 'text-soClean-180'
          )}
        >
          When enabled, winning entries will not be unsettled.
        </p>
      </label>
    </div>
  );
};
